import { FetchAgenciesByOrderIdDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchAgenciesByOrderId.data.context';
import { FetchCombinedCommunitiesByOrderIdDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchCombinedCommunitiesByOrderId.data.context';
import { FetchCombinedRatesDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchCombinedRates.data.context';
import { FetchMarketplaceCommunitiesByOrderIdDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchMarketplaceCommunitiesByOrderId.data.context';
import { FetchSelectedAgenciesRateDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchSelectedAgenciesRate.data.context';
import { FetchSelectedMarketplaceCommunitiesRateDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/FetchSelectedMarketplaceCommunitiesRate.data.context';
import { SelectAgenciesViewPropsProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/contexts/SelectAgenciesView.props.context';
import { SelectAgenciesViewComponent } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/SelectAgenciesView.component';
import { FC } from 'react';

export const SelectAgenciesView: FC = () => (
  <FetchMarketplaceCommunitiesByOrderIdDataProvider>
    <FetchAgenciesByOrderIdDataProvider>
      <FetchCombinedCommunitiesByOrderIdDataProvider>
        <FetchSelectedMarketplaceCommunitiesRateDataProvider>
          <FetchSelectedAgenciesRateDataProvider>
            <FetchCombinedRatesDataProvider>
              <SelectAgenciesViewPropsProvider>
                <SelectAgenciesViewComponent />
              </SelectAgenciesViewPropsProvider>
            </FetchCombinedRatesDataProvider>
          </FetchSelectedAgenciesRateDataProvider>
        </FetchSelectedMarketplaceCommunitiesRateDataProvider>
      </FetchCombinedCommunitiesByOrderIdDataProvider>
    </FetchAgenciesByOrderIdDataProvider>
  </FetchMarketplaceCommunitiesByOrderIdDataProvider>
);
